export default "__VITE_ASSET__JNwCSIMW__ 480w, __VITE_ASSET__C$uaZ04y__ 768w, __VITE_ASSET__fwDg2ceA__ 1200w, __VITE_ASSET__DN1g_U8B__ 1600w";